import { giphyBlack } from '@giphy/colors'
import styled from 'styled-components'
import IconButton from 'ui/src/components/controls/icon-button'

export const Navigation = styled.div`
    background: ${giphyBlack};
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px;
    position: sticky;
    top: 14px;
    width: 70px;
    z-index: 1;
`

export const Button = styled(IconButton)`
    display: block;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
`

export const CloseButton = styled(IconButton)`
    display: block;
    flex-shrink: 0;
    z-index: 1;
`
